'use strict';

module.exports = function (angularModule) {
  angularModule
      .service('globalSettingsRepository', require('./globalSettingsRepository'));
};



//////////////////
// WEBPACK FOOTER
// /app/~/redi-refdata-web-lib/dist/business/index.js
// module id = 128
// module chunks = 0